
<template id="rooms-template">
  <label>
    <input type="checkbox"
      :value="value"
      :checked="state"
      @change="onChange"
      >
    <span>{{ label }}</span>
  </label>
</template>

<script>
import checkbox from './checkbox.vue'

export default {
  mixins: [checkbox],
  name: 'rooms',
  props:  {
    modelValue: {
      default:  function () { return [] }
    }
  }
}
</script>


<style lang="scss">
.b-qrooms {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: 20px;
  // height: 40px;
  padding: 3px;
  border: 1px solid #e5e4e1;
  label {
    padding: 0;
    margin: 0;
    float: left;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    position: relative;
    color: #9c9c9c;
    font-size: 12px;
    margin: 0 1px;
    span {
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      &:hover {
        color: #4e4f52;
        background-color: #efe9dd;
        box-shadow: 0px 1px 3px 0px rgba(29, 19, 8, 0.13);
      }
    }
    input:checked~span {
      color: #fff;
      background-color: #ff6659;
      box-shadow: 0px 1px 3px 0px rgba(8, 11, 29, 0.13);
    }
  }
  input {
    display: none;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/rooms.vue